module.exports = __webpack_public_path__ + "static/media/kangyang-6@2x.fbc35597.png";